import { cn } from "@atlas/core";
import { getIconUrl } from "@shared";
import { useMemo } from "react";

export interface ICatalogIconProps {
  icon?: string;
  alt?: string;
  className?: string;
}

export function CatalogIcon({ icon, alt = "", className }: ICatalogIconProps) {
  const iconSrc = useMemo(() => getIconUrl(icon), [icon]);

  if (!iconSrc) {
    return null;
  }

  return (
    <div className="shrink-0">
      <img
        src={iconSrc}
        alt={alt}
        className={cn("size-12 rounded-md object-cover", className)}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
    </div>
  );
}
